import { BrickContext, Brick, registerBrick } from 'olympe';
import Unit from "../../../models/Unit";
import Observation from "../../../models/Observation";

export default class MobileLoadUnit extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} unit
     * @param {function()} forwardEvent
     * @param {function(*)} setLoadedUnit
     */
    async update($, [unit], [forwardEvent, setLoadedUnit]) {
        const observations = unit
            .follow(Unit.observationsRel).andReturn()
            .follow(Observation.targetRel).back()
            .follow(Observation.evalutationRel, true).back()
            .follow(Observation.additionalEvalsRel, true).andReturn();

        const systems = unit.follow(Unit.systemsRel).execute();

        const results = await Promise.all([observations, systems]);
        const key = `loaded_unit_${unit.getTag()}`;
        $.set(key, results);
        $.onClear(() => $.remove(key));

        setLoadedUnit(unit);
        forwardEvent();
    }
}

registerBrick('018bcd60f35a8162f3d6', MobileLoadUnit);
